export default "__VITE_ASSET__DRjPVESy__"